/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCCredentialCreateBodyParams } from '../models/TCCredentialCreateBodyParams';
import type { TCCredentialDeleteResponse } from '../models/TCCredentialDeleteResponse';
import type { TCCredentialGetResponse } from '../models/TCCredentialGetResponse';
import type { TCCredentialKind } from '../models/TCCredentialKind';
import type { TCCredentialRevealSecretResponse } from '../models/TCCredentialRevealSecretResponse';
import type { TCCredentialsListResponse } from '../models/TCCredentialsListResponse';
import type { TCCredentialUpdateBodyParams } from '../models/TCCredentialUpdateBodyParams';
import type { TCCredentialUpdateResponse } from '../models/TCCredentialUpdateResponse';
import type { TCCredentialUpdateSecretBodyParams } from '../models/TCCredentialUpdateSecretBodyParams';
import type { TCCredentialUpdateSecretResponse } from '../models/TCCredentialUpdateSecretResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class V1CredentialsService {
    /**
     * List credentials visible to the authenticated user.
     * @param limit
     * @param pageToken
     * @param provider
     * @param kind
     * @returns TCCredentialsListResponse Ok
     * @throws ApiError
     */
    public static listCredentials(
        limit?: number,
        pageToken?: string,
        provider?: string,
        kind?: TCCredentialKind,
    ): CancelablePromise<TCCredentialsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/credentials',
            query: {
                'limit': limit,
                'pageToken': pageToken,
                'provider': provider,
                'kind': kind,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a new credential owned by the authenticated user.
     * @param requestBody
     * @returns TCCredentialGetResponse Ok
     * @throws ApiError
     */
    public static createCredential(
        requestBody: TCCredentialCreateBodyParams,
    ): CancelablePromise<TCCredentialGetResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/credentials',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a credential by id if visible to the authenticated user.
     * @param credentialId
     * @returns TCCredentialGetResponse Ok
     * @throws ApiError
     */
    public static getCredential(
        credentialId: string,
    ): CancelablePromise<TCCredentialGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/credentials/{credentialId}',
            path: {
                'credentialId': credentialId,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update credential metadata (no secret changes).
     * @param credentialId
     * @param requestBody
     * @returns TCCredentialUpdateResponse Ok
     * @throws ApiError
     */
    public static updateCredential(
        credentialId: string,
        requestBody: TCCredentialUpdateBodyParams,
    ): CancelablePromise<TCCredentialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/credentials/{credentialId}',
            path: {
                'credentialId': credentialId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete a credential.
     * @param credentialId
     * @returns TCCredentialDeleteResponse Ok
     * @throws ApiError
     */
    public static deleteCredential(
        credentialId: string,
    ): CancelablePromise<TCCredentialDeleteResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/credentials/{credentialId}',
            path: {
                'credentialId': credentialId,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Rotate a credential secret payload (write-only).
     * @param credentialId
     * @param requestBody
     * @returns TCCredentialUpdateSecretResponse Ok
     * @throws ApiError
     */
    public static updateCredentialSecret(
        credentialId: string,
        requestBody: TCCredentialUpdateSecretBodyParams,
    ): CancelablePromise<TCCredentialUpdateSecretResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/credentials/{credentialId}/secret',
            path: {
                'credentialId': credentialId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Reveal a credential secret payload.
     * @param credentialId
     * @returns TCCredentialRevealSecretResponse Ok
     * @throws ApiError
     */
    public static revealCredentialSecret(
        credentialId: string,
    ): CancelablePromise<TCCredentialRevealSecretResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/credentials/{credentialId}/secret/reveal',
            path: {
                'credentialId': credentialId,
            },
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                500: `Internal Server Error`,
            },
        });
    }
}
